import { useEffect, useRef } from "react";

import { scroll } from "./helpers";

import Alert from "./components/Alert";

export default function Submitted() {
	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		scroll();
	});

	return (
		<div style={{ marginTop: "50px" }}>
			<Alert
				data={{
					type: "success",
					text: "Thank you for sharing your VTO story or memory. Your feedback is greatly appeciated in helping us create our key moments content leading up to next year’s event.",
				}}
			/>
		</div>
	);
}
